// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2FYCi","controls":"styles_controls__3glop","charLimit":"styles_charLimit__3vs0s","input":"styles_input__2lz-5","send":"styles_send__3FsnN"};